// スワイプ関連の共通定数と型定義

export const SWIPE_THRESHOLD = 150; // スワイプが発火するしきい値（px）

export type InteractionMethod =
  | "swipe"
  | "button"
  | "swipe_to_saved"
  | "swipe_to_visited"
  | "tap"
  | "tap_to_saved"
  | "tap_to_visited"
  | "disliked"
  | "saved_to_disliked"
  | "visited_to_disliked";

export type SwipeDirection = "left" | "right";

export type SwipeActionType = "bookmark" | "flag" | "delete";
